export const ENV_NAME = "Environment";
export const DATASOURCE = "Datasource";
export const DATASET = "Dataset";
export const ATTRIBUTE = "Attribute";
